import React from "react";


class RootLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { history } = this.props;

    history.push("/home");
  }

  render(){
      return (
          <div>hello</div>
      );
  }
}

export default RootLoader;